import { useEffect, useState } from 'react'

const getIsPageVisible = () => (
  typeof document === 'undefined' || document.visibilityState !== 'hidden'
)

/**
 * Returns false while the app is in the background (tab hidden, window
 * minimised, device locked) and true once it is in the foreground again.
 */
export const useIsPageVisible = () => {
  const [isPageVisible, setIsPageVisible] = useState(getIsPageVisible)

  useEffect(() => {
    const handleVisibilityChange = () => setIsPageVisible(getIsPageVisible())

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isPageVisible
}
